module.exports = __webpack_public_path__ + "static/img/erweima.cd513a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima.jpg
// module id = 5pkz
// module chunks = 16